export { ConnectedHotelSelectorDesktop } from './HotelSelectorDesktop';
export { default as HotelSelectorInputDesktop } from './HotelSelectorInputDesktop';
